// extracted by mini-css-extract-plugin
export var form = "_dc-0";